module.exports = __webpack_public_path__ + "static/media/step_2.92fb4670.jpg";